<template>
  <modal
    class="addNewRetainershipModal"
    name="addNewRetainershipModal"
    transition="pop-out"
    :width="modalWidth"
    :height="400"
  >
    <div class="retainership__box">
      <button
        type="button"
        class="close modal-close"
        aria-label="Close"
        @click="closeAddRetainershipModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="text-center">
        <h3 class="add__retainership__header mt-2">
          <span>
            <img src="@/assets/img/Group 484.png" width="50px" />
          </span>
          {{ $t("text.addNewRetainership.title") }}
        </h3>

        <div class="sign_up_form_section">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="firstname_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/user (1).png"
                        width="25px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="text"
                        :placeholder="$t('text.products.name')"
                        v-model="retainer.name"
                      />
                    </div>
                  </div>
                  <div ref="firstname_error_message"></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="lastname_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/user (1).png"
                        width="25px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="text"
                        :placeholder="$t('text.resetPassword.userName')"
                        v-model="retainer.username"
                      />
                    </div>
                  </div>
                  <div ref="lastname_error_message"></div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="username_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/email.png"
                        width="25px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="email"
                        :placeholder="$t('text.addNewRetainership.email')"
                        v-model="retainer.email"
                      />
                    </div>
                  </div>
                  <div ref="username_error_message"></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="phone_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/phone.png"
                        width="25px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="text"
                        :placeholder="$t('text.addNewRetainership.phoneNumber')"
                        v-model="retainer.phone"
                      />
                    </div>
                  </div>
                  <div ref="phone_error_message"></div>
                </div>
              </div>
            </div>

            <!-- <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="password_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/lock.png"
                        width="25px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="password"
                        :placeholder="$t('text.addNewRetainership.password')"
                        v-model="retainer.password"
                      />
                    </div>
                  </div>
                  <div ref="password_error_message"></div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="confirm_password_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/lock.png"
                        width="25px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="password"
                        :placeholder="
                          $t('text.addNewRetainership.confirmPassword')
                        "
                        v-model="retainer.confirmPassword"
                      />
                    </div>
                  </div>
                  <div ref="confirm_password_error_message"></div>
                  <div ref="invalid_password_format" class="password_error">
                    <p>{{ $t("text.profile.passwordMustContain") }},</p>
                    <ul>
                      <li>{{ $t("text.profile.oneNumbericCharacter") }}</li>
                      <li>{{ $t("text.profile.oneSpecialCharacter") }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form_input_section mt-4">
                  <div class="input__div" ref="referral_input_div">
                    <div class="small_placeholder_div">
                      <img
                        src="@/assets/img/whitehand.svg"
                        width="30px"
                        class="input_placeholder_icon"
                      />
                    </div>
                    <div class="input_field_section">
                      <input
                        type="text"
                        :placeholder="
                          $t('text.addNewRetainership.openingBalance')
                        "
                        v-model="retainer.openingBalance"
                      />
                    </div>
                  </div>
                  <div ref="referral_error_message"></div>
                </div>
              </div>
            </div> -->

            <div class="text-center mt-5">
              <button
                style="background-color: #46266e"
                class="add_quick_fuel_btn"
                @click="addRetainership($event)"
                :disabled="isButtonDisabled ? true : null"
                :style="[
                  isButtonDisabled
                    ? { cursor: 'not-allowed' }
                    : { cursor: 'pointer' },
                ]"
              >
                {{ $t("text.addNewRetainership.add") }} <span></span>
              </button>
              <img
                src="@/assets/img/git_loader.gif"
                style="display: none"
                width="35px"
                class="ml-3 loader"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
import configObject from "@/config";
import JQuery from "jquery";
let $ = JQuery;

const MODAL_WIDTH = 700;

export default {
  name: "RetainershipModal",
  props: ["company"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      retainer: {
        username: "",
        phone: "",
        name: "",
        email: "",
        // lastName: "",
        // password: "",
        // confirmPassword: "",
        // openingBalance: "",
      },
      formIsValid: false,
      isButtonDisabled: false,
    };
  },
  created() {
    this.showLoader = true;
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },
  methods: {
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },
    closeAddRetainershipModal() {
      this.$modal.hide("addNewRetainershipModal");
    },
    addRetainership($event) {
      $event.preventDefault();

      // if (!this.retainer.password) {
      //   this.$toast.open({
      //     message: this.$t("text.errors.passwordMissing"),
      //     type: "error",
      //     duration: 2000,
      //   });
      //   return;
      // } else {
      //   if (
      //     (this.retainer.password.length > 0 &&
      //       this.retainer.password.length < 6) ||
      //     this.retainer.password.length > 100
      //   ) {
      //     this.$toast.open({
      //       message: this.$t("text.errors.shortPassword"),
      //       type: "error",
      //       duration: 2000,
      //     });
      //     return;
      //   }
      // }
      // if (!this.retainer.confirmPassword) {
      //   this.$toast.open({
      //     message: this.$t("text.addNewRetainership.confirmPasswordMissing"),
      //     type: "error",
      //     duration: 2000,
      //   });
      //   return;
      // } else {
      //   if (this.retainer.password !== this.retainer.confirmPassword) {
      //     this.$toast.open({
      //       message: this.$t("text.addNewRetainership.passwordsDontMatch"),
      //       type: "error",
      //       duration: 2000,
      //     });
      //     return;
      //   }
      // }
      if (!this.retainer.name) {
        this.$toast.open({
          message: this.$t("text.errors.nameMissing"),
          type: "error",
          duration: 2000,
        });
        return;
      }
      // if (!this.retainer.username) {
      //   this.$toast.open({
      //     message: this.$t("text.errors.lastNameMissing"),
      //     type: "error",
      //     duration: 2000,
      //   });
      //   return;
      // }
      if (!this.retainer.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 2000,
        });
        return;
      } else if (!this.validEmail(this.retainer.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 2000,
        });
        return;
      }
      if (!this.retainer.phone) {
        this.$toast.open({
          message: this.$t("text.errors.contactPhoneMissing"),
          type: "error",
          duration: 2000,
        });
        return;
      } else {
        const phoneStr = new String(this.retainer.phone);
        if (phoneStr.length < 10 || phoneStr.length > 13) {
          this.$toast.open({
            message: this.$t("text.errors.shortPhoneNumber"),
            type: "error",
            duration: 2000,
          });
          return;
        }
      }

      // const newOpeningBalance = !this.retainer.openingBalance
      //   ? 0
      //   : parseFloat(this.retainer.openingBalance);
      // let data = { ...this.retainer, openingBalance: newOpeningBalance };
      let data = this.retainer;
      console.log(data);

      this.isButtonDisabled = true;
      $(".loader").show();

      //changing content type
      const config = configObject.authConfig({ isRemis: true });
      config.headers["Content-Type"] = "application/json";

      console.log(config);
      this.axios
        .post(
          `${configObject.remisBaseUrl}/d/retainership/clientsignup/${this.company.id}`,
          data,
          config
        )
        .then(() => {
          $(".loader").hide();
          this.isButtonDisabled = false;
          this.closeAddRetainershipModal();
          this.$toast.open({
            message: this.$t("text.addNewRetainership.successfullyAdded"),
            type: "success",
            duration: 10000,
          });
          this.$eventHub.$emit("getRetainerships");
          data = null;
          this.retainer = {
            username: "",
            phone: "",
            name: "",
            email: "",
            // lastName: "",
            // password: "",
            // confirmPassword: "",
            // openingBalance: "",
          };
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 10000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
